import { PETICIONES, VALID_URLS } from 'src/app/core/utils/constants';

/** Petición en la que no incluimos el token de acceso sino el token de refresco en la cabecera */
export const AUTH_PETICION_REFRESH = PETICIONES.login.refresh;
/** Peticiones en las que no incluimos la cabecera de Autorización */
export const AUTH_PETICIONES_NO_AUTH = [
  PETICIONES.prueba,
  VALID_URLS.GETUNIQID,
  VALID_URLS.AUTHENTICATIONPROCESS,
  PETICIONES.login.login
];

/**peticion que hacemos para el login */
export const AUTH_PETICIONES_LOGIN = PETICIONES.login.login;